import { render, staticRenderFns } from "./DNSResolverList.vue?vue&type=template&id=78e1e9e4&scoped=true&"
import script from "./DNSResolverList.vue?vue&type=script&lang=ts&"
export * from "./DNSResolverList.vue?vue&type=script&lang=ts&"
import style0 from "./DNSResolverList.vue?vue&type=style&index=0&id=78e1e9e4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e1e9e4",
  null
  
)

export default component.exports